<template>
  <RouterView v-slot="{ Component }">
    <Suspense>
      <Transition>
        <component :is="Component" />
      </Transition>
    </Suspense>
  </RouterView>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'

import { useUserStore } from './stores/user-store'

const { locale } = useI18n()
const { applyPreset } = useColors()
const store = useUserStore()

locale.value = store.language || 'en'
applyPreset(store.theme || 'light')
</script>
<style lang="scss">
@use './scss/main.scss';

#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}

.v-enter-active,
.v-leave-active {
  transition: opacity filter 2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
